"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var adaptive_1 = __importDefault(require("./adaptive"));
var Small = function (_a) {
    var fill = _a.fill, title = _a.title, background = _a.background, rest = __rest(_a, ["fill", "title", "background"]);
    return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 91 91", fill: "none", version: "1.1" }, rest),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("circle", { cx: "45.5", cy: "45.5", r: "45.5", fill: fill }),
        react_1.default.createElement("path", { d: "M 45.5,21 C 55.9934,21 64.5,29.53146 64.5,40.0556 64.5,53.6667 49.5714,70 45.5,70 41.4286,70 26.5,53.6667 26.5,40.0556 26.5,29.52056 35.00659,21 45.5,21 Z M 45.5,33.25 C 41.7524,33.25 38.7143,36.297 38.7143,40.0556 38.7143,43.8142 41.7524,46.8611 45.5,46.8611 49.2476,46.8611 52.2857,43.8142 52.2857,40.0556 52.2857,36.297 49.2476,33.25 45.5,33.25 Z", fill: "#ffffff" })));
};
var Map = function (props) {
    var _a = props.fill, fill = _a === void 0 ? '#F99459' : _a, rest = __rest(props, ["fill"]);
    return react_1.default.createElement(adaptive_1.default, __assign({ small: Small, fill: fill, shift: -5 }, rest));
};
exports.default = Map;
